module.exports = "/_next/static/images/DefaultThumbnail-d5ef731fc7a921c5df5aaffdc7439f51.png";